import React, { useState } from "react";
import { batchStatusUpdate } from "../../../api/Batch";
import { closeModal, SweetAlertShow } from "../../master/Master";

export default function BatchStatusUpdate({ modalData, handleFunction }) {
  const [loading, setLoading] = useState(false);
  const handleUpdateBatchStatus = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData(e.target);
    try {
      const response = await batchStatusUpdate(formData);
      if (response?.data?.status) {
        closeModal("editStatusModal");
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
      handleFunction();
    }
  };

  return (
    <div
      className="modal fade"
      id="editStatusModal"
      tabIndex="-1"
      aria-labelledby="editStatusModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header bg-label-primary p-3">
            <h1 className="modal-title fs-5" id="editStatusModalLabel">
              Update Batch Status{}
            </h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <form onSubmit={handleUpdateBatchStatus}>
            <div className="modal-body">
              <div className="form-floating form-floating-outline mb-4">
                <input type="hidden" name="id" value={modalData?.id} />
                <select
                  className="form-select"
                  id="status"
                  name="status"
                  required
                >
                  <option selected={Number(modalData?.status) === 0} value="0">
                    New Batch
                  </option>
                  <option selected={Number(modalData?.status) === 1} value="1">
                    Running Batch
                  </option>
                  <option selected={Number(modalData?.status) === 2} value="2">
                    Finished Batch
                  </option>
                </select>
                <label htmlFor="batchStatus">Select Batch Status</label>
              </div>
            </div>
            <div className="modal-footer bg-label-primary p-3">
              <button
                type="button"
                className="btn btn-danger"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-primary px-5"
                disabled={loading}
              >
                {loading ? (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                ) : (
                  "Submit"
                )}
                {loading ? " Submitting..." : ""}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
